module.exports = __webpack_public_path__ + "img/ellipsis.3853decb.png";